<!--
    描述：企业账户 --- 更多收支记录明细
    时间：2020-12-29
    Created by ws
-->
<template>
    <div class="detail-main">
        <div class="detail-container">
            <div class="top">
                <div class="top-box">
                    <div class="nav">
                        <ul>
                            <li
                                :class="{ active: activeIndex === 0 }"
                                @click="changeRange(0)"
                            >
                                今日
                            </li>
                            <li
                                :class="{ active: activeIndex === 1 }"
                                @click="changeRange(1)"
                            >
                                本周
                            </li>
                            <li
                                :class="{ active: activeIndex === 2 }"
                                @click="changeRange(2)"
                            >
                                本月
                            </li>
                            <!-- <li
                                :class="{ active: activeIndex === 3 }"
                                @click="changeRange(3)"
                            >
                                近三月
                            </li> -->
                        </ul>
                    </div>
                    <div class="content">
                        <div class="money-text">
                            收入:
                            <span class="income">{{
                                parseFloat(incomeTotal).toFixed(2)
                            }}</span>
                        </div>
                        <div class="money-text">
                            支出:
                            <span class="expend">{{
                                parseFloat(expendTotal).toFixed(2)
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="top-box" id="chart_box"></div>
            </div>
            <div class="bottom">
                <div class="header">
                    <span>合计：{{ total }} 笔</span>
                </div>
                <div class="w-table-layout w-table-page">
                    <div class="w-table-content">
                        <el-table
                            border
                            :data="tableData"
                            ref="xTable"
                            size="mini"
                            height="100%"
                            class="records-table"
                        >
                            <el-table-column
                                type="index"
                                label="序号"
                                width="55px"
                                show-overflow-tooltip
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                prop="tradeNo"
                                label="收支明细流水号"
                                width="220"
                                align="center"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="changeTime"
                                label="变更时间"
                                width="180"
                                align="center"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="curAmount"
                                label="现有金额(元)"
                                width="120"
                                header-align="center"
                                align="right"
                                show-overflow-tooltip
                            >
                                <template slot-scope="scope">
                                    <div>
                                        {{ (parseFloat(scope.row.curAmount) / 100).toFixed(2) }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="oriAmount"
                                label="原始金额(元)"
                                width="120"
                                header-align="center"
                                align="right"
                                show-overflow-tooltip
                            >
                                <template slot-scope="scope">
                                    <div>
                                        {{ (parseFloat(scope.row.oriAmount) / 100).toFixed(2) }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="chgAmount"
                                label="变更金额(元)"
                                width="120"
                                header-align="center"
                                align="right"
                                show-overflow-tooltip
                            >
                                <template slot-scope="scope">
                                    <div>
                                        {{ (parseFloat(scope.row.chgAmount) / 100).toFixed(2) }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="type"
                                label="交易类型"
                                width="150"
                                align="center"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="remark"
                                label="分账备注"
                                min-width="150"
                                align="center"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="accountName"
                                label="业务备注"
                                min-width="200"
                                align="center"
                                show-overflow-tooltip
                            ></el-table-column>
                        </el-table>
                    </div>
                    <div class="w-table-footer">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="pageList"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                            size="mini"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail-footer hidden">
            <el-button class="btn cancel-btn" size="small" @click="goBack">返回</el-button>
        </div>
    </div>
</template>

<script>
import { dateFormat } from "utils/tools.js";
import { getAccountDetail } from "api/modules/account";

export default {
    data() {
        return {
            activeIndex: 0, // 当前激活的 范围菜单
            incomeTotal: 0, // 收入合计
            expendTotal: 0, // 支出合计
            tableData: [],
            currentPage: 1,
            pageList: [10, 20, 30, 50, 100],
            pageSize: 10,
            total: 0,
            dayList: [dateFormat("yyyy-mm-dd"), dateFormat("yyyy-mm-dd")],
        };
    },
    created() {
        // console.log(this.curWeek);
        // console.log(this.curMonth);
        if (this.bizUserId !== '') {
            this.doSearch()
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initCharts();
        });
    },
    methods: {
        // 点击返回
        goBack() {
            this.$router.push({
                path: "/about-account-withdraw",
            });
        },

        // 切换展示范围
        changeRange(index) {
            this.currentPage = 1
            this.activeIndex = index;
            switch (index) {
                case 0: // 本日
                    this.dayList = [dateFormat("yyyy-mm-dd"), dateFormat("yyyy-mm-dd")];
                    this.doSearch();
                    break;
                case 1: // 本周
                    this.dayList = [this.curWeek.startDay, this.curWeek.endDay];
                    this.doSearch();
                    break;
                case 2: // 本月
                    this.dayList = [this.curMonth.startDay, this.curMonth.endDay];;
                    this.doSearch();
                    break;
                default:
                    return;
            }
        },

        // 查询数据
        doSearch() {
            let params = {
                bizUserId: this.bizUserId, //-----商户系统中唯一编号
                dateStart: this.dayList[0], // -----开始时间（开始时间和结束时间相差不能超过一个月，后台也会提示）
                dateEnd: this.dayList[1], // -----结束时间
                current: this.currentPage,
                size: this.pageSize, // -----页面大小（如果取前五条，把"size":"5"，结束时间传当前时间）
            };
            // console.log(params);
            getAccountDetail(params).then((res) => {
                if (res.operationCode === 1) {
                    this.tableData = res.data.records;
                    this.total = parseInt(res.data.total);

                    // 计算 收支
                    if (res.data.records.length > 0) {
                        this.amountTotal(res.data.records);
                    } else {
                        this.incomeTotal = 0
                        this.expendTotal = 0
                    }
                }
            });
        },

        // 计算收支总额
        amountTotal(list) {
            // 今日
            // if (this.activeIndex === 0) {

            // } else {
            //     // 遍历每一天 计算
            //     list.map(obj => {

            //     })
            // }
            // let incomeTotal = 0;
            // let expendTotal = 0;

            this.incomeTotal = 0;
            this.expendTotal = 0;

            // 收入数组求和
            let _increase = list.filter((x) => parseFloat(x.chgAmount) > 0);
            _increase = _increase.map((x) => {
                return x.chgAmount;
            });
            this.incomeTotal = (parseFloat(_increase.sum()) / 100).toFixed(2);

            // 支出数组求和
            let _decrease = list.filter((x) => parseFloat(x.chgAmount) < 0);
            _decrease = _decrease.map((x) => {
                return x.chgAmount;
            });
            this.expendTotal = (
                parseFloat(
                    _decrease.map((x) => {
                        return Math.abs(x);
                    }).sum()
                ) / 100
            ).toFixed(2);
        },

        // 切换显示条数
        handleSizeChange(size) {
            this.pageSize = size;
            this.doSearch();
        },

        // 切换当前页
        handleCurrentChange(cur) {
            this.currentPage = cur;
            this.doSearch();
        },

        // 获取状态文字
        getStatus(status) {
            let obj = {
                text: "",
                className: "",
            };

            if (!status && status !== 0) {
                return obj;
            }

            // 正规流程
            switch (status) {
                case 0:
                    obj.text = "处理中";
                    break;
                case 1:
                    obj.text = "已到帐";
                    obj.className = "is-success";
                    break;
                case 2:
                    obj.text = "提现失败";
                    obj.className = "is-failed";
            }

            return obj;
        },

        // 渲染 echarts 图表
        initCharts() {
            let dom = document.getElementById("chart_box");
            let _chart = this.$echarts.init(dom);

            let color = ["#8B5CFF", "#00CA69"];

            let xAxisData = [
                "12-28",
                "12-29",
                "12-30",
                "12-31",
                "01-01",
                "01-02",
                "01-03",
            ];
            let yAxisData1 = [100, 138, 350, 173, 180, 150, 180, 230];
            let yAxisData2 = [233, 233, 200, 180, 199, 233, 210, 180];

            const hexToRgba = (hex, opacity) => {
                let rgbaColor = "";
                let reg = /^#[\da-f]{6}$/i;
                if (reg.test(hex)) {
                    rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
                        "0x" + hex.slice(3, 5)
                    )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
                }
                return rgbaColor;
            };

            let option = {
                backgroundColor: "#fff",
                color: color,
                legend: {
                    top: 20,
                },
                tooltip: {
                    trigger: "axis",
                    formatter: function (params) {
                        let html = "";
                        if (params.length > 0) {
                            html += `<div>${params[0].axisValue}</div>`;
                        }
                        params.forEach((v) => {
                            html += `<div style="color: #666;font-size: 14px;line-height: 24px">
                                <span style="margin-right: 10px">${v.seriesName}</span>
                                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                                    color[v.componentIndex]
                                };"></span>
                            <span style="color:${
                                color[v.componentIndex]
                            };font-weight:700;font-size: 18px;x">${v.value}</span>元`;
                        });
                        return html;
                    },
                    extraCssText:
                        "background: #fff; border-radius: 0;box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);color: #333;",
                    axisPointer: {
                        type: "shadow",
                        shadowStyle: {
                            color: "#ffffff",
                            shadowColor: "rgba(225,225,225,1)",
                            shadowBlur: 5,
                        },
                    },
                },
                grid: {
                    top: 100,
                    bottom: 20,
                    left: 40,
                    right: 40,
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: "category",
                        boundaryGap: false,
                        axisLabel: {
                            // formatter: "2020-{value}",
                            textStyle: {
                                color: "#333",
                            },
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#D9D9D9",
                            },
                        },
                        data: xAxisData,
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "收支曲线（元）",
                        axisLabel: {
                            textStyle: {
                                color: "#666",
                            },
                        },
                        nameTextStyle: {
                            color: "#666",
                            fontSize: 12,
                            lineHeight: 40,
                        },
                        // 分割线
                        splitLine: {
                            lineStyle: {
                                type: "dashed",
                                color: "#E9E9E9",
                            },
                        },
                        axisLine: {
                            show: true,
                        },
                        axisTick: {
                            // show: true,
                        },
                    },
                ],
                series: [
                    {
                        // name: "2018",
                        name: "收入",
                        type: "line",
                        smooth: true,
                        symbolSize: 8,
                        zlevel: 3,
                        lineStyle: {
                            normal: {
                                color: color[0],
                                shadowBlur: 3,
                                shadowColor: hexToRgba(color[0], 0.5),
                                shadowOffsetY: 8,
                            },
                        },
                        symbol: "circle", //数据交叉点样式
                        areaStyle: {
                            normal: {
                                color: this.$echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: hexToRgba(color[0], 0.3),
                                        },
                                        {
                                            offset: 1,
                                            color: hexToRgba(color[0], 0.1),
                                        },
                                    ],
                                    false
                                ),
                                shadowColor: hexToRgba(color[0], 0.1),
                                shadowBlur: 10,
                            },
                        },
                        data: yAxisData1,
                    },
                    {
                        name: "支出",
                        type: "line",
                        smooth: true,
                        symbolSize: 8,
                        zlevel: 3,
                        lineStyle: {
                            normal: {
                                color: color[1],
                                shadowBlur: 3,
                                shadowColor: hexToRgba(color[1], 0.5),
                                shadowOffsetY: 8,
                            },
                        },
                        symbol: "circle", //数据交叉点样式 (实心点)
                        areaStyle: {
                            normal: {
                                color: this.$echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: hexToRgba(color[1], 0.3),
                                        },
                                        {
                                            offset: 1,
                                            color: hexToRgba(color[1], 0.1),
                                        },
                                    ],
                                    false
                                ),
                                shadowColor: hexToRgba(color[1], 0.1),
                                shadowBlur: 10,
                            },
                        },
                        data: yAxisData2,
                    },
                ],
            };
            _chart.setOption(option);

            // 窗口移动事件
            window.onresize = () => {
                _chart.resize();
            };
        },
    },
    computed: {
        // 本周的起始日期
        curWeek() {
            let now = new Date(); //当前日期
            let nowDay = now.getDate(); //当前日
            let nowDayOfWeek = now.getDay(); //本周的 第几天
            let nowMonth = now.getMonth(); //当前月
            let nowYear = now.getFullYear(); //当前年
            //本月的开始时间
            let weekStartDate = new Date(nowYear, nowMonth, nowDay + 1 - nowDayOfWeek);
            //本月的结束时间
            let weekEndDate = new Date(nowYear, nowMonth, nowDay + 7 - nowDayOfWeek);
            return {
                startDay: dateFormat("yyyy-mm-dd", weekStartDate),
                endDay: dateFormat("yyyy-mm-dd", weekEndDate),
            };
        },

        // 当前月份的起始日期
        curMonth() {
            let now = new Date(); //当前日期
            let nowMonth = now.getMonth(); //当前月
            let nowYear = now.getFullYear(); //当前年
            //本月的开始时间
            let monthStartDate = new Date(nowYear, nowMonth, 1);
            //本月的结束时间
            let monthEndDate = new Date(nowYear, nowMonth + 1, 0);
            return {
                startDay: dateFormat("yyyy-mm-dd", monthStartDate),
                endDay: dateFormat("yyyy-mm-dd", monthEndDate),
            };
        },

        // 主键ID
        bizUserId() {
            return this.$route.query.bizUserid
        }
    },
};
</script>

<style scoped lang="less">
.detail-main {
    height: 100%;
    overflow: hidden;
    position: relative;
    // padding-bottom: 45px;
    background-color: #fff;

    .detail-container {
        height: 100%;
        padding: 20px;
        padding-bottom: 0;

        .top {
            height: 40%;
            display: flex;
            justify-content: space-between;
        }

        .top-box {
            width: 49%;
            height: 100%;
            border: 1px solid #ddd;
        }

        .bottom {
            height: 60%;
            padding-top: 10px;
        }

        .header {
            height: 40px;
            line-height: 40px;
            border-top: 1px dashed #ccc;
            margin-top: 10px;
        }

        .w-table-layout {
            height: calc(~"100% - 50px");
        }
    }

    .detail-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 45px;
        line-height: 42px;
        text-align: center;
    }

    .nav {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ddd;

        ul {
            height: 41px;
            overflow: hidden;
        }

        li {
            height: 40px;
            font-size: 14px;
            font-weight: 600;
            color: #202020;
            float: left;
            padding: 0 15px;
            cursor: pointer;
        }

        .active {
            border-bottom: 3px solid #2671cc;
            color: #2671cc;
        }
    }

    .content {
        height: calc(~"100% - 40px");
        display: flex;
        align-items: center;
        justify-content: space-around;

        .money-text {
            font-size: 14px;
        }

        .income {
            color: #72aa2c;
            font-size: 18px;
        }

        .expend {
            color: #e60012;
            font-size: 18px;
        }
    }
}
</style>
